import { Box, Menu, MenuItem } from '@mui/material'
import { useState, MouseEvent } from 'react'
import styled from 'styled-components'
import { colors } from 'constants/theme'
import { FollowUpPatientStatus, patientStatuses } from 'constants/patient-statuses'

/**
 * เดิมใช้ react-bootstrap <Dropdown> (Toggle + Menu) — ย้ายมาเป็น MUI <Menu>
 * DropdownToggle จำลองหน้าตา .btn + caret (.dropdown-toggle::after) ของ bootstrap ไว้เอง
 * เพราะเมื่อเลิกใช้ Dropdown.Toggle แล้ว class เหล่านั้นหายไป (bootstrap.min.css ยัง global อยู่ก็จริง แต่ Box ไม่ได้ class)
 * ใช้ transient props ($bg/$isdisabled) เพื่อไม่ให้ค่ารั่วลง DOM เพราะ Box เป็น div จริง
 */
export const DropdownToggle = styled(Box)<{ $bg: string; $isdisabled: '0' | '1' }>(({ $bg, $isdisabled }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    height: '24px',
    padding: '6px 12px',
    fontSize: '1rem',
    borderRadius: '4px',
    border: '1px solid transparent',
    backgroundColor: $bg || '#FFF3E5',
    cursor: $isdisabled === '1' ? 'default' : 'pointer',
    pointerEvents: $isdisabled === '1' ? 'none' : 'auto',
    '::after': {
        content: '""',
        display: $isdisabled === '1' ? 'none' : 'inline-block',
        marginLeft: '0.255em',
        verticalAlign: '0.255em',
        borderTop: '0.3em solid',
        borderRight: '0.3em solid transparent',
        borderBottom: 0,
        borderLeft: '0.3em solid transparent'
    }
}))

const DropdownItem = styled(MenuItem)(({ theme }) => ({
    color: colors.textPrimary,
    '&:hover': {
        backgroundColor: colors.themeSecondColor06,
        color: colors.themeSecondColor
    }
}))

const StatusSelectorCustoms = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '.user-approvel': {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '12px',
        'path': {
            fill: '#A8A8A8'
        },
        '.user-fullname': {
            color: '#808080'
        }
    }
}))

type StatusSelectorCustomProps = {
    status: FollowUpPatientStatus
    onChange?: (data: FollowUpPatientStatus) => void
    disabled?: boolean
    onClick?: (value: boolean) => void
    unshow?: boolean
    optionPatientStatuses?: any
}

export const StatusSelectorCustom = (props: StatusSelectorCustomProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const isDisabled = Boolean(props.unshow || props.disabled)

    const handleOpen = (event: MouseEvent<HTMLElement>) => {
        if (isDisabled) return
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => setAnchorEl(null)

    return (
        <StatusSelectorCustoms className={`box-approvel-selector`}>
            <Box className={`approvel-selector`}>
                <DropdownToggle
                    className="btn-table-action text-white shadow-none"
                    $bg={props.disabled ? `#AEAFAF !important` : `${props.optionPatientStatuses?.[props.status]?.color || patientStatuses?.[props.status]?.color} !important`}
                    $isdisabled={isDisabled ? '1' : '0'}
                    onClick={handleOpen}
                    sx={{
                        width: 'fit-content',
                        minWidth: '105px',
                        whiteSpace: 'nowrap',
                        position: 'relative'
                    }}
                >
                    <Box paddingBottom="6px" >{props.optionPatientStatuses?.[props.status]?.icon || patientStatuses?.[props.status]?.icon}</Box>
                    <Box sx={{ color: 'white', fontSize: '14px', whiteSpace: 'nowrap' }}>{props.optionPatientStatuses?.[props.status]?.statusName || patientStatuses?.[props.status]?.statusName}</Box>
                </DropdownToggle>
                {!props.disabled && (
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >
                        {Object.entries(props.optionPatientStatuses || patientStatuses).map(([key, info]: any) => (
                            <DropdownItem
                                key={key}
                                sx={{ minWidth: '105px', whiteSpace: 'nowrap' }}
                                onClick={() => {
                                    props.onChange?.(key as FollowUpPatientStatus)
                                    handleClose()
                                }}
                            >{info?.statusName}
                            </DropdownItem>
                        ))}
                    </Menu>
                )}
            </Box>
        </StatusSelectorCustoms >
    )
}
